import { createMemoryHistory, createBrowserHistory } from "history";
import { Action, configureStore, Tuple } from "@reduxjs/toolkit";
import { ThunkAction } from "redux-thunk";
import { createReduxHistoryContext } from "redux-first-history";

import createRootReducer from "./rootReducer";
import rootReducer from "./rootReducer";

interface Arg {
  // initialState?: typeof window.__INITIAL_STATE__;
  initialState?: any;
  url?: string;
}

// Create browser or memory history
const history = createBrowserHistory();

const { createReduxHistory, routerMiddleware, routerReducer } =
  createReduxHistoryContext({ history });

// Use inferred return type for making correct Redux types
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createStore = ({ initialState }: Arg = {}) => {
  const store = configureStore({
    reducer: createRootReducer(routerReducer), 
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
    // devTools: __DEV__,
  });

  return { store, history: createReduxHistory(store) };
};

const { store } = createStore();

// if (__DEV__ && typeof window !== "undefined") {
//   (window as any).store = store;
// }

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, AppState, unknown, Action<string>>;

export default createStore;